import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import each from 'lodash/each'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'cargamasiva',
    ...crudState(),
    respuesta: [],
    cantidad: ''
  }),
  getters: {
    ...crudGetters,
    respuesta: state => state.respuesta,
    cantidad: state => state.cantidad
  },
  mutations: {
    ...crudMutations,
    setRespuesta: (state, data) => {
      if (data) {
        state.respuesta = data
      }
    },
    setCantidad: (state, data) => {
      if (data) {
        state.cantidad = data
      }
    }
  },
  actions: {
    ...crudActions,
    async cargaMasiva ({ commit }, { endpoint, dataToSend }) {
      const formData = new FormData()

      each(dataToSend, (value, key) => formData.append(key.toUpperCase(), value))
      // commit('setLoading', 1, { root: true })

      try {
        const response = await axios.post(endpoint, formData, { baseURL: process.env.VUE_APP_API_URL, headers: { 'Content-Type': 'multipart/form-data' } })
        // commit('setLoading', -1, { root: true })

        if (typeof response.data === 'object') {
          commit('setRespuesta', response.data)
          commit('setCantidad', response.data)
        } else {
          const result = response.data.split('\n').filter((res) => {
            return res !== ''
          })
          const result2 = result[0].slice(1, -1).split('}{')

          /**
                     * aqui tomo el ulimo elemento del arreglo que contiene los registros exitosos, los separo por comas,
                     * el siguiente array que obtengo se estrae su ultimo elemento = "Registered Contacts OK", para luego unir el ultimo array y
                     * obetener el ultimo elemento
                     * "Result":{"ERROR":"Identificador ya existe para Contacto","linea":"2"}
                     * Luego tomo ese ultimo elemento y lo uno al array originar = result2.push(result5)
                     * **/

          // let result3 = result2.pop().split(',')

          // "Registered Contacts OK: ":0 separo por : y extraigo nuevamente el ulitmo valor que es 0
          const result3 = result2.pop()

          // let result5 = result3.join(',')
          // result2.push(result5)

          commit('setRespuesta', result2.map(element => {
            return JSON.parse(element.slice(9))
          }))

          commit('setCantidad', result3)

          return result2.map(element => {
            return JSON.parse(element.slice(9))
          })
        }
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  }
}
